"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var DateField_1 = __importDefault(require("../../../Form/fields/DateField"));
var PomuckyTable_1 = require("../Pomucky/PomuckyTable");
var FlexConteiner = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: left;\n"], ["\n  display: flex;\n  align-items: left;\n"])));
var StyledH2 = styled_components_1.default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 140%;\n  color: #000000;\n  margin-top: 0;\n"], ["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 140%;\n  color: #000000;\n  margin-top: 0;\n"])));
var StyledSpan = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 1em;\n  font-weight: bold;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n"], ["\n  margin-right: 1em;\n  font-weight: bold;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n"])));
var StyledCheckbox = styled_components_1.default(antd_1.Checkbox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  .ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n"], ["\n  .ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n"])));
var ZapisPojisteni = function (_a) {
    var _b;
    var idOsoby = _a.idOsoby, druhOsoby = _a.druhOsoby, refetchPojisteni = _a.refetchPojisteni, datumZapisu = _a.datumZapisu, name = _a.name, setIsPojisteniLoaded = _a.setIsPojisteniLoaded;
    var pojisteniUrl = __1.useConfig().pojisteniUrl;
    var postJSON = __1.usePostJSON(pojisteniUrl + "/PojisteniOsoby");
    var _c = formik_1.useField(name), field = _c[0], helpers = _c[2];
    var values = field.value;
    var loadPojisteni = function (idZnalce) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, postJSON({ idZnalce: idZnalce, infoOnly: true, datumZapisu: datumZapisu })];
                case 1:
                    response = _a.sent();
                    if (__1.isRight(response)) {
                        helpers.setValue({ upusteniOdDolozeni: response.value.upusteniOdDolozeni, idPojisteni: response.value.id, pojisteniDate: response.value.aktualniDatumDolozeni });
                        if (setIsPojisteniLoaded)
                            setIsPojisteniLoaded(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getWorkingDate = function (days) {
        var currentDate = new Date(Date.now());
        var direction = days < 0 ? -1 : 1;
        var day = days;
        while (day !== -direction) {
            if (currentDate.getDay() !== 6 && currentDate.getDay() !== 0)
                day -= direction;
            if (day !== -direction)
                currentDate.setDate(currentDate.getDate() + direction);
        }
        return currentDate;
    };
    react_1.useEffect(function () {
        if (idOsoby) {
            loadPojisteni(idOsoby);
        }
        else {
            helpers.setValue(__assign(__assign({}, values), { pojisteniDate: getWorkingDate(60).toISOString() }));
        }
    }, [refetchPojisteni]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledH2, null, "Profesn\u00ED poji\u0161t\u011Bn\u00ED"),
        druhOsoby !== __1.ZnalciDruhOsoby.znalec || !(values === null || values === void 0 ? void 0 : values.upusteniOdDolozeni) ? (react_1.default.createElement(__1.Field, null,
            react_1.default.createElement(StyledSpan, null, "Term\u00EDn pro dolo\u017Een\u00ED dokladu o poji\u0161t\u011Bn\u00ED"),
            react_1.default.createElement(DateField_1.default, { name: "pojisteni.pojisteniDate", size: "md", clearIcon: null, minDate: new Date('2000-01-01') }))) : (react_1.default.createElement(PomuckyTable_1.Negativni, { isDetail: false }, "Subjekt nem\u00E1 povinnost b\u00FDt poji\u0161t\u011Bn.")),
        druhOsoby === __1.ZnalciDruhOsoby.znaleckyUstav && (react_1.default.createElement(__1.Field, null,
            react_1.default.createElement(StyledSpan, null, "Nem\u00E1 povinnost b\u00FDt poji\u0161t\u011Bn podle \u00A7 22 odst. 2"),
            react_1.default.createElement(FlexConteiner, null,
                react_1.default.createElement(StyledCheckbox, { type: "checkBox", name: "pojisteni.upusteniOdDolozeni", onChange: function () { return helpers.setValue(__assign(__assign({}, values), { upusteniOdDolozeni: !(values === null || values === void 0 ? void 0 : values.upusteniOdDolozeni) })); }, checked: (_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.upusteniOdDolozeni }))))));
};
ZapisPojisteni.defaultProps = {
    idOsoby: undefined,
    druhOsoby: undefined,
    datumZapisu: undefined,
    refetchPojisteni: false,
    setIsPojisteniLoaded: undefined,
};
exports.default = ZapisPojisteni;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
